import React, { useEffect } from "react";
import cn from "classnames";
import { PageTitle, PageTitleProps } from "components";

import "./ListPageTitle.scss";

export interface ListPageTitleProps extends PageTitleProps {}

export const ListPageTitle = ({
  className,
  children,
}: React.PropsWithChildren<ListPageTitleProps>) => {
  useEffect(() => {
    //TEMPORARY CODE , NEEDS UPDATE TITLE FUNCTION , I DIDN'T LIKED METHOD ALREADY USED SO WHEN TITLE TAG IS CALLED I WROTE IT IN TITLE TAG.
    // Update the document title when the component mounts
    if (typeof children === "string") {
      document.title = `Aversi Clinic - ${children}`;
    }

    // Optionally, you can clean up the title when the component unmounts
    return () => {
      document.title = "Aversi Clinic";
    };
  }, [children]);

  return (
    <PageTitle className={cn(className, "listpage-title")}>
      {children}
    </PageTitle>
  );
};
